import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { RadioInputComponent } from './component/radio/radio.component';
import { CUSpinnerComponent } from './component/spinner/spinner.component';
@NgModule({
  declarations: [RadioInputComponent, CUSpinnerComponent],
  exports: [RadioInputComponent, CUSpinnerComponent],
  imports: [CommonModule, RouterModule, SharedUiLibraryModule],
  providers: []
})
export class LegacyModule {}
